import React from 'react';
import PropTypes from 'prop-types';

// Transient, auto-dismissing confirmations (add to cart, removed, new photos,
// errors). Replaces the inline flash/cue banners so the page chrome stays calm.
const ICON = { success: '✓', error: '!', info: '✨' };

const ToastStack = ({ toasts, onDismiss }) => {
  if (!toasts.length) return null;
  return (
    <div className="sg-toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`sg-toast sg-toast--${t.type}`}>
          <span className="sg-toast-icon" aria-hidden="true">{ICON[t.type] || ICON.info}</span>
          <span>{t.message}</span>
          <button type="button" className="sg-toast-x" aria-label="Dismiss" onClick={() => onDismiss(t.id)}>
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

ToastStack.propTypes = {
  toasts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    message: PropTypes.string,
  })).isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default ToastStack;
